import React, { Component } from 'react';
import { dateFromLocalToUTC, dateFromUTCToLocal } from '../../services/common-functions';
import DatePicker from 'react-date-picker';
import LabeledSpanInput from '../labeled-span-input';
import PropTypes from 'prop-types';

class LabeledDatePicker extends Component {

    handleDateChange = date => {

        this.props.onChange( dateFromLocalToUTC( date ) );

    }

    render () {

        const date = dateFromUTCToLocal( this.props.selected );
        return (
            <LabeledSpanInput className="labeled-span-input" labelNeedsTranslation={false} label={this.props.label}>
                <DatePicker
                    value={date}
                    onChange={this.handleDateChange}
                    name={this.props.name}
                    minDate={this.props.minDate}
                    maxDate={this.props.maxDate}
                    dayPlaceholder="DD"
                    monthPlaceholder="MM"
                    yearPlaceholder="YYYY"
                    format={this.props.dateFormat}
                    disabled={this.props.disabled}
                />
            </LabeledSpanInput>
        );

    }

}

LabeledDatePicker.displayName = 'LabeledDatePicker';
LabeledDatePicker.propTypes = {
    name: PropTypes.string.isRequired,
    selected: PropTypes.oneOfType( [PropTypes.string, PropTypes.number] ),
    label: PropTypes.string.isRequired,
    minDate: PropTypes.number,
    maxDate: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    dateFormat: PropTypes.string,
    disabled: PropTypes.bool
};

export default LabeledDatePicker;
